import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const BannerContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: 4px;
`;
